import styled from "styled-components"
import { colors } from '../../../helpers/consts'
import main_bg from '../../../images/Main_BG.svg'

export const Section = styled.section`
  background-color: ${colors.lightBlue};
  width: 100%;
  padding: 5.6rem 0 2rem;
  background-image: url(${main_bg});
  background-size: 100% auto;
  background-position: bottom;
  background-repeat: no-repeat;

  @media (min-width: 48em) {
    padding: 9.4rem 0 6rem;
  }

  @media (min-width: 62em) {
    padding: 11.6rem 0 8rem;
  }

  @media (min-width: 112em) {
    padding: 19.6rem 0 16rem;
  }
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;

  @media (min-width: 48em) {
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: nowrap;
  }
`

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 1rem;

  @media (min-width: 48em) {
    align-items: flex-start;
    text-align: left;
    margin-bottom: 0;
  }
`

export const SectionImage = styled.img`
  max-width: 28rem;
  position: relative;
  right: -2rem;

  @media (min-width: 48em) {
    max-width: 48rem;
  }

  @media (min-width: 62em) {
    max-width: 64rem;
    right: -4rem;
  }
`

export const SectionTitle = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  color: ${colors.darkBlue};
  line-height: 1.07;
  margin-bottom: 1rem;

  @media (min-width: 30em) {
    font-size: 3rem;
  }

  @media (min-width: 48em) {
    font-size: 4.2rem;
    margin-bottom: 2rem;
  }

  @media (min-width: 62em) {
    font-size: 6.6rem;
    line-height: 7.9rem;
    max-width: 34rem;
    margin-bottom: 4rem;
  }
`
